import * as Application from 'expo-application';
import Constants from 'expo-constants';
import { Platform } from 'react-native';

export const getDeviceId = async (): Promise<string> => {
  let deviceId: string;
  if (Platform.OS === 'ios') {
    const iosId = await Application.getIosIdForVendorAsync();
    deviceId = iosId || '';
  } else if (Platform.OS === 'android') {
    const androidId = Application.androidId;
    deviceId = androidId || '';
  } else {
    deviceId = Constants.installationId;
  }
  return deviceId;
};
